import React from 'react';
import {render} from 'react-dom';
import App from 'ondemand/containers/App';
import {createBrowserHistory} from 'history';
import {applyMiddleware, compose, createStore, combineReducers} from 'redux';
import thunkMiddleware from 'redux-thunk';
import {connectRouter, routerMiddleware} from 'connected-react-router';

import reducers from 'ondemand/reducers';
import commonReducers from 'common/reducers';

import InternalApi from 'common/api/InternalApi';
import OndemandApi from 'common/api/OndemandApi';
import UserApi from 'common/api/UserApi';

import BugsnagService from 'common/services/BugsnagService';
import DirectionsService from 'common/services/DirectionsService';

import {Route, Switch} from 'react-router-dom';
import {Provider} from 'react-redux';
import {ConnectedRouter} from 'connected-react-router';

import OndemandBase from 'ondemand/components/OndemandBase';

import MomentUtils from '@date-io/moment';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import {popAllAlerts} from 'ondemand/actions/alert';

import 'moment-timezone';


const history = createBrowserHistory();


// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// new root reducer with router state
const createRootReducer = (history) => combineReducers({
  router: connectRouter(history),
  ...reducers,
  ...commonReducers,
});

const store = createStore(
  createRootReducer(history),
  composeEnhancers(
    applyMiddleware(
      routerMiddleware(history), // for dispatching history actions
      thunkMiddleware.withExtraArgument({
        api: new OndemandApi(),
        bugsnagService: new BugsnagService(),
        directionsService: new DirectionsService(),
        internalApi: new InternalApi(),
        userApi: new UserApi(),
      }),
    ),
  ),
);

history.listen(() => {
  store.dispatch(popAllAlerts());
});

render(
  <Provider store={store}>
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <ConnectedRouter history={history}>
        <OndemandBase>
          <Switch>
            <Route path="/" component={App} />
          </Switch>
        </OndemandBase>
      </ConnectedRouter>
    </MuiPickersUtilsProvider>
  </Provider>,
  document.getElementById('app'),
);



// WEBPACK FOOTER //
// ./src/ondemand/index.js